"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@seaweb/coral/hoc/styled"));
var react_window_1 = require("react-window");
var react_acdc_1 = require("@seaweb/react-acdc");
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var internals_1 = require("./internals");
var SelectContext_1 = require("./SelectContext");
var SelectList_1 = require("./SelectList");
var SelectScroller_1 = __importDefault(require("./SelectScroller"));
var ChildrenArrayContext = react_1.createContext(null);
var VirtualizedSelectOption = function (_a) {
    var style = _a.style, index = _a.index;
    var element = react_1.useContext(ChildrenArrayContext)[index];
    return react_1.cloneElement(element, {
        index: index,
        style: __assign(__assign({}, style), element.props.style),
    });
};
var InnerListElement = styled_1.default.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: 0;\n"], ["\n  padding-left: 0;\n"])));
var OuterListForwardedPropsContext = react_1.createContext(null);
var OuterListElement = react_1.forwardRef(function OuterListElement(_a, ref) {
    var children = _a.children, virtualizedStyle = _a.style, props = __rest(_a, ["children", "style"]);
    var _b = react_1.useContext(OuterListForwardedPropsContext), listRef = _b.listRef, _c = _b.as, as = _c === void 0 ? 'div' : _c, styleProp = _b.style, emptyPlaceholder = _b.emptyPlaceholder, listProps = __rest(_b, ["listRef", "as", "style", "emptyPlaceholder"]);
    var elements = react_1.useContext(ChildrenArrayContext);
    var showPlaceholder = emptyPlaceholder !== null && !react_1.Children.count(elements);
    var position = virtualizedStyle.position, height = virtualizedStyle.height, fixedVirtualizedStyle = __rest(virtualizedStyle, ["position", "height"]);
    var style = __assign(__assign({ height: showPlaceholder ? null : height }, fixedVirtualizedStyle), styleProp);
    return (react_1.default.createElement(SelectScroller_1.default, __assign({ as: as, ref: useForkRef_1.default(listRef, ref), style: style }, props, listProps), showPlaceholder ? react_1.default.createElement(SelectList_1.EmptyPlaceholder, null, emptyPlaceholder) : children));
});
var DEFAULT_ESTIMATED_ITEM_SIZE = 36;
var DEFAULT_GET_ITEM_SIZE = function () { return 36; };
var SelectVirtualizedList = react_1.forwardRef(function SelectVirtualizedList(_a, ref) {
    var children = _a.children, _b = _a.width, widthProp = _b === void 0 ? 'auto' : _b, _c = _a.height, height = _c === void 0 ? 300 : _c, _d = _a.estimatedItemSize, estimatedItemSize = _d === void 0 ? DEFAULT_ESTIMATED_ITEM_SIZE : _d, _e = _a.itemSize, itemSize = _e === void 0 ? DEFAULT_GET_ITEM_SIZE : _e, _f = _a.overscanCount, overscanCount = _f === void 0 ? 20 : _f, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, _g = _a.emptyPlaceholder, emptyPlaceholder = _g === void 0 ? 'No Data' : _g, props = __rest(_a, ["children", "width", "height", "estimatedItemSize", "itemSize", "overscanCount", "onBlur", "onKeyDown", "emptyPlaceholder"]);
    var _h = __read(react_acdc_1.useAcdcPopupProps(), 1), _j = _h[0], popupRef = _j.ref, acdcBlur = _j.onBlur, acdcKeyDown = _j.onKeyDown, popupProps = __rest(_j, ["ref", "onBlur", "onKeyDown"]);
    var handleBlur = useWrapEvent_1.default(onBlur, acdcBlur);
    var handleKeyDown = useWrapEvent_1.default(onKeyDown, acdcKeyDown);
    var handleRef = useForkRef_1.default(ref, popupRef);
    var setOptionChild = SelectContext_1.useSelectContext().setOptionChild;
    react_1.useEffect(function () {
        react_1.Children.forEach(children, function (child, index) {
            setOptionChild(index, child.props.children);
        });
    });
    var _k = react_acdc_1.useAcdcContext().state, isOpen = _k.isOpen, keyboardHighlightedIndex = _k.keyboardHighlightedIndex;
    var vListRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (isOpen) {
            vListRef.current.scrollToItem(keyboardHighlightedIndex);
        }
    }, [keyboardHighlightedIndex, isOpen]);
    var width = internals_1.useSelectListWidth(widthProp);
    var childrenArray = react_1.Children.toArray(children);
    return (react_1.default.createElement(ChildrenArrayContext.Provider, { value: childrenArray },
        react_1.default.createElement(OuterListForwardedPropsContext.Provider, { value: __assign(__assign({ listRef: handleRef, width: width, onBlur: handleBlur, onKeyDown: handleKeyDown, emptyPlaceholder: emptyPlaceholder }, popupProps), props) },
            react_1.default.createElement(react_window_1.VariableSizeList, { ref: vListRef, innerElementType: InnerListElement, outerElementType: OuterListElement, width: width, height: height, itemCount: react_1.Children.count(children), itemSize: itemSize, estimatedItemSize: estimatedItemSize, overscanCount: overscanCount }, VirtualizedSelectOption))));
});
exports.default = react_1.memo(SelectVirtualizedList);
var templateObject_1;
